<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button" *ngIf="!active.snapshot.paramMap.get('meucadastro')"></i>
    </ion-button>

    <ion-title>{{'Perfil' | translate}}</ion-title>

    <ion-col class="end-filter" *ngIf="pessoa.nome">
      <i class="fa-solid fa-qrcode qr-code" (click)="qrCode(pessoa)"></i>
    </ion-col>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded && pessoa.nome">
  <div class="gradient-extendido"></div>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <div class="div-imagem-extendido">
          <div class="img-wrapper">
            <img [src]="pessoa.foto | image:' '" />
          </div>

          <div style="width: 50%">
            <h2 class="nome-pessoa">{{pessoa.nome}}</h2>
            <h3 class="nome-insti">
              {{pessoa.instituicao.nome ? pessoa.instituicao.nome : ('Não Informado' | translate)}}
            </h3>

            <ion-grid>
              <ion-row class="ion-justify-content-center" *ngIf="(meuCadastro && pessoa?.tipoPessoa) || (!meuCadastro && userProvider?.hasConfig(117))">
                <ion-col size="12">
                  <div class="nome-insti border-cols bold-2" text-capitalize>
                    {{pessoa.tipoPessoa ? pessoa.tipoPessoa : ''}} {{pessoa.subTipoPessoa ? '/' : ''}}
                    {{pessoa.subTipoPessoa ? pessoa.subTipoPessoa : ''}}
                  </div>
                </ion-col>
              </ion-row>

              <ion-row
                class="ion-justify-content-center"
                *ngIf="userProvider.hasConfig(189) && statusPessoaTipo && permissaoStatus"
              >
                <ion-col>
                  <div>
                    <div class="nome-insti border-cols bold-2">{{statusPessoa}}: {{statusPessoaTipo}}</div>
                  </div>
                </ion-col>
              </ion-row>

              <ion-row class="ion-justify-content-center">
                <ion-col size="6" *ngIf="pessoa.apelido">
                  <div class="nome-insti border-cols bold-2">{{pessoa.apelido}}</div>
                </ion-col>

                <ion-col size="6" *ngIf="pessoa.codigo">
                  <div class="nome-insti border-cols bold-2">{{'ID' | translate}} {{pessoa.codigo}}</div>
                </ion-col>
              </ion-row>

              <ion-row class="ion-justify-content-center" *ngIf="pessoa.outorga">
                <ion-col size="12">
                  <div class="nome-insti border-cols bold-2">
                    {{pessoa.outorga?.ocorrencia}} {{pessoa.outorga?.data | dateFormat:'ddmmyyyy'}}
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid style="display: flow-root">
    <ion-row>
      <ion-item>
        <ion-label class="titulo">{{'Configurações gerais' | translate}}</ion-label>
      </ion-item>

      <ion-col size="12">
        <ion-list (click)="openDadosGerais();">
          <ion-item>
            <i class="fas fa-address-book icon-cad"></i>

            <ion-label>
              <h2 class="item-title">{{'Dados gerais' | translate}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <!-- <ion-col size="12">
        <ion-list (click)="openProfissional();">
          <ion-item>
            <i class="fa-solid fa-briefcase icon-cad"></i>

            <ion-label>
              <h2 class="item-title">{{'Perfil profissional' | translate}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col> -->

      <ion-col size="12">
        <ion-list (click)="openParticipacao();">
          <ion-item>
            <i class="fa fa-users icon-cad"></i>

            <ion-label>
              <h2 class="item-title">{{'Participações' | translate}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <ion-col *ngIf="meuCadastro" size="12">
        <ion-list (click)="openConfiguracao();">
          <ion-item>
            <i class="fas fa-cog icon-cad"></i>

            <ion-label>
              <h2 class="item-title">{{'Configurações' | translate}}</h2>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>

      <ion-col *ngIf="meuCadastro" size="12" (click)="notificacoes();">
        <ion-list>
          <ion-item>
            <i class="fa-solid fa-bell icon-cad"></i>

            <ion-label>
              <h2 class="item-title">{{'Notificações' | translate}}</h2>
            </ion-label>

            <ion-badge color="danger" slot="end" *ngIf="notificationsLength > 0">{{notificationsLength}}</ion-badge>
          </ion-item>
        </ion-list>
        <div class="linha-horizontal"></div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid *ngIf="meuCadastro" style="padding-bottom: 20px">
    <ion-row class="ion-justify-content-center" style="text-align: center" (click)="sair()">
      <ion-col size="3" style="justify-content: center; display: flex">
        <ion-label class="exit">
          <i class="fa-solid fa-right-from-bracket"></i>

          {{'Sair' | translate}}
        </ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-content *ngIf="loaded && !pessoa.nome">
  <sem-registro
    [notFound]="false"
    [text]="'Você não tem permissão para acessar esta tela. Entre em contato com a instituição.'"
  ></sem-registro>
</ion-content>
